export const TABLE_CHECKBOX_COLUMN_ID = 'checkbox';
export const TABLE_SPLIT_HEADER_Z_INDEX = 20;
export const TABLE_CHECKBOX_HEADER_Z_INDEX = 2;
export const TABLE_CHECKBOX_CELL_Z_INDEX = 1;
